import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Loader } from '@els/els-react--loader';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { activationFromEmailLink } from '@Containers/RemoteAccess/RemoteAccessService';

function RemoteAccessLogin(props) {
  // eslint-disable-next-line camelcase
  const { selfmanraToken: selfManRaToken, grantType: grant_type } = props;

  useEffect(() => {
    // eslint-disable-next-line camelcase
    activationFromEmailLink({ selfManRaToken, grant_type }).catch(Logger.error);
    RouteChangeTracking.trackOnRouteChangeSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader />;
}

RemoteAccessLogin.propTypes = {
  selfmanraToken: PropTypes.string,
  grantType: PropTypes.string,
};

export default RemoteAccessLogin;
